import { useEffect, useState } from "react";
import { Table, Card, Text, Button } from "@nextui-org/react";
import { TbSortAscending } from "react-icons/tb";
import { formatSecondHandProduct } from "../../utils/secondHandProduct";

const columns = [
  { key: "time", label: "Time" },
  { key: "product", label: "Product" },
  { key: "imei", label: "IMEI" },
  { key: "condition", label: "Condition" },
  { key: "customer", label: "Customer" },
  { key: "cash", label: "Cash" },
  { key: "upi", label: "UPI" },
  { key: "card", label: "Card" },
  { key: "mix", label: "Mix" },
  { key: "total", label: "Total" },
];

const PurchasesTable = (props) => {
  const [list, setList] = useState([]);
  const [currentSort, setCurrentSort] = useState({
    field: "created",
    asc: false,
  });
  const changeCurrentSort = (field, asc) => {
    setCurrentSort({ field: field, asc: asc });
  };

  useEffect(() => {
    if (props.list?.length > 0) {
      const listCopy = [...props.list];
      let sortCurrent;

      if (currentSort.field === "phone") {
        sortCurrent = listCopy.sort((a, b) => {
          let fa = formatSecondHandProduct(a);
          let fb = formatSecondHandProduct(b);
          if (fa < fb) {
            return -1;
          }
          if (fa > fb) {
            return 1;
          }
          return 0;
        });
      } else if (currentSort.field === "total") {
        sortCurrent = listCopy.sort((a, b) => {
          return a?.purchaseAmount - b?.purchaseAmount;
        });
      } else {
        sortCurrent = listCopy.sort((a, b) => {
          return new Date(a.created) - new Date(b.created);
        });
      }

      setList(currentSort.asc ? sortCurrent : sortCurrent.reverse());
    } else {
      setList([]);
    }
  }, [currentSort, props.list]);

  return (
    <Card variant="bordered" className="cardShadow" css={{ maxW: "1200px" }}>
      <Card.Header css={{ p: 0 }}>
        <Text h4 css={{ margin: 0, padding: "20px 20px 0px 20px" }}>
          Purchases
        </Text>
      </Card.Header>
      <Card.Body css={{ p: 0 }}>
        <Table
          striped
          aria-label="Purchases List"
          compact
          sticked
          shadow={false}
        >
          <Table.Header>
            {columns.map((column) => {
              return (
                <Table.Column key={column.key} css={{ color: "black" }}>
                  <div className="tableColumn">
                    {column.label}&nbsp;&nbsp;&nbsp;
                    <Button
                      auto
                      light
                      size="xs"
                      onClick={() =>
                        changeCurrentSort(column.key, !currentSort.asc)
                      }
                    >
                      <TbSortAscending />
                    </Button>
                  </div>
                </Table.Column>
              );
            })}
          </Table.Header>
          <Table.Body
            css={{ textAlign: "start", fontWeight: 600, verticalAlign: "top" }}
          >
            {list?.map((doc) => {
              return (
                <Table.Row
                  key={doc._id}
                  css={{
                    borderRadius: "12px",
                    alignItems: "start",
                    fontSize: "14px",
                  }}
                >
                  <Table.Cell css={{ width: "120px" }}>
                    {new Date(doc?.created)?.toLocaleTimeString("en-IN", {
                      timeZone: "Asia/Kolkata",
                    })}
                  </Table.Cell>
                  <Table.Cell>
                    {formatSecondHandProduct(doc)}
                  </Table.Cell>
                  <Table.Cell>{doc?.imei}</Table.Cell>
                  <Table.Cell>{doc?.condition}</Table.Cell>
                  <Table.Cell>{doc?.name}</Table.Cell>
                  <Table.Cell>
                    {doc?.paymentMethod === "Cash"
                      ? `₹ ${doc?.purchaseAmount}`
                      : "-"}
                  </Table.Cell>
                  <Table.Cell>
                    {doc?.paymentMethod === "UPI"
                      ? `₹ ${doc?.purchaseAmount}`
                      : "-"}
                  </Table.Cell>
                  <Table.Cell>
                    {doc?.paymentMethod === "Card"
                      ? `₹ ${doc?.purchaseAmount}`
                      : "-"}
                  </Table.Cell>
                  <Table.Cell>
                    {doc?.paymentMethod === "Mix"
                      ? `₹ ${doc?.purchaseAmount}`
                      : "-"}
                  </Table.Cell>
                  <Table.Cell>&#8377; {doc?.purchaseAmount}</Table.Cell>
                </Table.Row>
              );
            })}
          </Table.Body>
        </Table>
      </Card.Body>
    </Card>
  );
};

export default PurchasesTable;
